module.exports = __webpack_public_path__ + "img/element2.536b74ee.svg";